module.exports = __webpack_public_path__ + "static/four-out-of-5-176746a4fc422427b74d68105de8850c.webp";